import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { PartnershipCard, ValidationResponse } from '@models/swagger';
import { ValidatePartnershipCardParams } from './service';

export enum ValidatePartnershipCardActions {
  Failure = '[Application Utilities ValidatePartnershipCard] Failure',
  Request = '[Application Utilities ValidatePartnershipCard] Request',
  Success = '[Application Utilities ValidatePartnershipCard] Success',
}

export const ValidatePartnershipCardFailure = createAction(
  ValidatePartnershipCardActions.Failure,
  props<{ error: HttpErrorResponse }>()
);

export const ValidatePartnershipCardRequest = createAction(
  ValidatePartnershipCardActions.Request,
  props<{ body: PartnershipCard; parameters: ValidatePartnershipCardParams }>()
);

export const ValidatePartnershipCardSuccess = createAction(
  ValidatePartnershipCardActions.Success,
  props<{ data: ValidationResponse }>()
);
